var map = {
	"./classe.svg": "f545",
	"./docx.svg": "72a5",
	"./file.svg": "5722",
	"./link_upload.svg": "ab08",
	"./pdf.svg": "967e",
	"./photo.svg": "6dab",
	"./pptx.svg": "5975",
	"./video_file_upload.svg": "c0a2",
	"./xlsx.svg": "bec4",
	"./youtube.svg": "01f0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "055d";